import lottie from "lottie-web"

const Forms = () => {

	for (const form of document.querySelectorAll('form')) {

		// Animate loading spinner
		const anim = lottie.loadAnimation({
			container: form.querySelector('.spinner'), // the dom element that will contain the animation
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData: {"assets":[],"layers":[{"ddd":0,"ind":0,"ty":4,"nm":"Shape Layer 1","ks":{"o":{"k":100},"r":{"k":0},"p":{"k":[300,300,0]},"a":{"k":[0,0,0]},"s":{"k":[244,244,100]}},"ao":0,"shapes":[{"d":1,"ty":"el","s":{"k":[100,100]},"p":{"k":[0,0]},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse"},{"ty":"tm","s":{"k":[{"i":{"x":[0.439],"y":[1.016]},"o":{"x":[0.561],"y":[0.015]},"n":["0p439_1p016_0p561_0p015"],"t":5,"s":[100],"e":[0]},{"t":33.0000013441176}],"ix":1},"e":{"k":[{"i":{"x":[0.439],"y":[1.017]},"o":{"x":[0.561],"y":[0.016]},"n":["0p439_1p017_0p561_0p016"],"t":0,"s":[100],"e":[0]},{"t":30.0000012219251}],"ix":2},"o":{"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim"},{"ty":"st","fillEnabled":true,"c":{"k":[0.35294117647058826,0.3686274509803922,0.3803921568627451,1]},"o":{"k":100},"w":{"k":16},"lc":2,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke"}],"ip":0,"op":900.000036657751,"st":0,"bm":0,"sr":1}],"v":"4.5.3","ddd":0,"ip":1.00000004073083,"op":33.0000013441175,"fr":29.9700012207031,"w":600,"h":600} // the json animation data
		});

		form.addEventListener('submit', (e) => {
			form.classList.add('form--is-submitting');
			form.querySelector('button[type="submit"]').setAttribute('disabled', 'true');
		})
	}

	// Get checkbox groups that require validation
	const checkboxGroups = document.querySelectorAll('[data-validate="checkbox-group"]')

	// Loop through checkboxgroups
	for (const checkboxGroup of checkboxGroups) {

		// Check if group is valid
		checkGroupIsValid(checkboxGroup)

		// Whenever any checkbox changed, check if group is valid
		for (const i of checkboxGroup.querySelectorAll('input')) {

			i.addEventListener('change', function(e) {
				checkGroupIsValid(checkboxGroup)
			})
		}

	}
}

const checkGroupIsValid = (group) => {

	// Loop through inputs in group to check if at least one selected
	let isValid    = false
	let x          = 0
	let firstInput = null

	// Loop through inputs in group
	for (const i of group.querySelectorAll('input')) {
		
		// If any input checked, set group as valid
		if (i.checked) {
			isValid = true
		}

		// Get first input in loop
		if (x == 0) {
			firstInput = i
		}

		x++
	}

	// If not valid, add validation message, else clear it
	if (!isValid) {

		firstInput.setCustomValidity("Please select at least one of these options")

	} else {

		firstInput.setCustomValidity("")

	}
}

export default Forms;
